import React, { FC } from 'react';
import styles from './commentary_list.module.scss';
import { PaperCommentaryCard } from '../card/PaperCommentaryCard';
import { PaperCommentary } from '../commentary.types';

type Props = {
  commentary: PaperCommentary;
};

export const CommentaryListPaperCommentary: FC<Props> = (props: Props) => (
  <PaperCommentaryCard
    {...props}
    className={`${styles.commentaryItem} ${styles.commentaryPaper}`}
  />
);
